if (window.FacebookPromNight == null) {
  window.FacebookPromNight = {};
}

FacebookPromNight.init = function(payload, done) {
  return $(function() {
    $(".share-links .icon-facebook").on({
      click: function(e) {
        e.preventDefault();
        return window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent($(this).attr('href')), '_blank', 'width=626,height=436');
      }
    });
    return done();
  });
};

module.exports = FacebookPromNight;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9zaGFyaW5nL2Zyb250ZW5kL2ZhY2Vib29rLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvc2hhcmluZy9mcm9udGVuZC9mYWNlYm9vay5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtFQUFBLE1BQU0sQ0FBQyxvQkFBcUI7OztBQUU1QixpQkFBaUIsQ0FBQyxJQUFsQixHQUF5QixTQUFDLE9BQUQsRUFBVSxJQUFWO1NBQ3ZCLENBQUEsQ0FBRSxTQUFBO0lBQ0EsQ0FBQSxDQUFFLDZCQUFGLENBQWdDLENBQUMsRUFBakMsQ0FBb0M7TUFBQSxLQUFBLEVBQU8sU0FBQyxDQUFEO1FBQ3pDLENBQUMsQ0FBQyxjQUFGLENBQUE7ZUFDQSxNQUFNLENBQUMsSUFBUCxDQUFZLCtDQUFBLEdBQWdELGtCQUFBLENBQW1CLENBQUEsQ0FBRSxJQUFGLENBQU8sQ0FBQyxJQUFSLENBQWEsTUFBYixDQUFuQixDQUE1RCxFQUFzRyxRQUF0RyxFQUFnSCxzQkFBaEg7TUFGeUMsQ0FBUDtLQUFwQztXQUlBLElBQUEsQ0FBQTtFQUxBLENBQUY7QUFEdUI7O0FBU3pCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
